module.exports = __webpack_public_path__ + "img/customer-icon-18.085a9440.png";